// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2zkbH","head":"ProcedureTableInfo_head__15wV0"};